<div elementDataTest="achievementItemContainer" class="achievement o-hidden d-flex flex-column relative">
    <app-loader *ngIf="downloading$ | async" loaderType="cover" overlayColor="new-loader-grey" loaderSize="s"></app-loader>
    <div [ngClass]="achievement.type" class="header w-100 d-flex justify-content-center align-items-center">
        <app-icon class="tw-fill-white" [name]="achievement.type | achievementIcon" [type]="achievement.type | achievementIconType"></app-icon>
    </div>
    <div class="d-flex flex-column description flex-grow-1 text-quaternary">
        <div>
            <div class="name text-m font-bold">{{ achievement.name }}</div>
            <div class="d-flex align-items-center">
                <div class="circle d-flex align-items-center justify-content-center border-secondary bg-secondary me-2">
                    <app-icon name="checked" class="tw-fill-white tw-w-2.5 tw-h-2.5"></app-icon>
                </div>
                <div class="achieved text-xs">
                    {{ 'v3-achievements-badge-achieved-on' | translate: { date: (achievement.stats.achieved.date?.ts | date) } }}
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end align-items-end flex-grow-1">
            <button
                [ariaLabel]="'v3-challenge-passed-share-linkedin' | translate"
                tooltipClass="secondary-tooltip"
                container="body"
                [ngbTooltip]="'add-achievement' | translate"
                class="share"
                (click)="shareLinkedin()"
                buttonDataTest="shareLinkedinButton"
            >
                <app-icon name="linkedin" class="tw-w-6 tw-h-6 tw-fill-primary"></app-icon>
            </button>
            <button
                [ariaLabel]="'v3-achievements-badge-download-type' | translate: { type: achievement.type, name: achievement.name }"
                [ngbTooltip]="!achievement.attachment.pdf ? '' : ('v3-button-download' | translate)"
                tooltipClass="secondary-tooltip"
                container="body"
                [disabled]="!achievement.attachment.pdf"
                (click)="downloadPdf($event)"
                class="download"
                linkDataTest="downloadLink"
            >
                <app-icon name="download" class="tw-w-6 tw-h-6 tw-fill-primary"></app-icon>
            </button>
        </div>
    </div>
</div>
